import { jwtDecode } from "jwt-decode";

// Get a new token 60 seconds before it expires
const expirationTimeBuffer = 60;

/** True once sign-in has stored tokens. Used to gate authenticated queries so
 *  they don't fire on public screens like login. */
export const hasAuthToken = (): boolean => !!localStorage.getItem("id_token");

export const isTokenExpired = (token) => {
  if (!token) return true;
  const { exp } = jwtDecode(token);
  const now = Date.now() / 1000;
  // console.log("⌚ Time left on token:", exp && (exp - now), exp && (exp - now - expirationTimeBuffer));
  return !exp || exp - expirationTimeBuffer < now;
};

export const refreshAccessToken = async (): Promise<string> => {
  try {
    // Get refresh token from localStorage
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) {
      throw new Error("No refresh token found in localStorage");
    }

    // Parse the refresh token if it's stored as JSON
    const parsedRefreshToken = refreshToken.startsWith('"')
      ? JSON.parse(refreshToken)
      : refreshToken;

    // Exchange via our backend proxy, which holds the Cognito app client
    // secret server-side (the secret must never ship in the browser bundle).
    const apiEndpoint = (import.meta as any).env.VITE_APP_HL_API_ENDPOINT;
    if (!apiEndpoint) {
      throw new Error(
        "Missing required environment variable: VITE_APP_HL_API_ENDPOINT",
      );
    }

    const tokenEndpoint = `${apiEndpoint}/auth/token`;

    const response = await fetch(tokenEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        grant_type: "refresh_token",
        refresh_token: parsedRefreshToken,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Token refresh failed: ${response.status} ${response.statusText} - ${errorText}`,
      );
    }

    const tokenData = await response.json();

    // Extract the new ID token
    const newIdToken = tokenData.id_token;
    if (!newIdToken) {
      throw new Error("No ID token received from refresh response");
    }

    // Update localStorage with new tokens
    localStorage.setItem("id_token", newIdToken);

    // Update access token if provided
    if (tokenData.access_token) {
      localStorage.setItem("access_token", tokenData.access_token);
    }

    // Update refresh token if a new one is provided
    if (tokenData.refresh_token) {
      localStorage.setItem("refresh_token", tokenData.refresh_token);
    }

    return newIdToken;
  } catch (error) {
    if (!error.message.includes("No refresh token found in localStorage")) {
      console.error("Token refresh failed:", error);
    }
    throw error;
  }
};

//export const refreshAccessToken = () => {
//  return new Promise((resolve, reject) => {
//    const cognitoUser = userPool.getCurrentUser();
//    if (!cognitoUser) {
//       return reject(new Error("No current user"));
//     }

//     cognitoUser.getSession((err, session) => {
//       if (err) {
//         return reject(err);
//       }

//       const refreshToken = session.getRefreshToken();

//       cognitoUser.refreshSession(refreshToken, (err, session) => {
//         if (err) {
//           return reject(err);
//         }
//         const newIdToken = session.getIdToken().getJwtToken();
//         const newAccessToken = session.getAccessToken().getJwtToken();

//         localStorage.setItem("id_token", newIdToken);
//         localStorage.setItem("access_token", newAccessToken);

//         resolve(newAccessToken);
//       });
//     });
//   });
// };
